import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import AboutChubb from '../about-chubb/AboutChubb';
import AboutOurData from '../about-our-data/AboutOurData';
import RequestForm from '../request-form/RequestForm';
import FooterLinks from './FooterLinks';

interface FooterProps {
  componentLocation?: string;
}

const Footer: React.FC<FooterProps> = ({ componentLocation = 'dashboard' }) => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  return (
    <Box
      sx={{
        width: componentLocation === 'dashboard' && !isSm ? 'calc(100% - 57px)' : '100%',
        overflow: 'hidden',
        ml: { xs: 0, md: componentLocation === 'dashboard' ? '57px' : '0' }, // Align with left drawer (collapsed state)
        transition: 'margin-left 0.3s',
      }}
    >
      <AboutChubb componentLocation={componentLocation} />
      <AboutOurData componentLocation={componentLocation} />
      {/* Request form appears on dashboard footer */}
      {componentLocation === 'dashboard' && (
        <>
          <RequestForm componentLocation={componentLocation} />
          <FooterLinks />
        </>
      )}
    </Box>
  );
};

export default Footer;
